export const E_SIGN_AGREMENT = {
	url: 'https://privacyportal-cdn.onetrust.com/f28abd65-17b0-4df7-b558-d20b86121b10/privacy-notices/4989756a-0195-422b-976c-15cb5982d465.json',
	tokenId: 'otnotice-4989756a-0195-422b-976c-15cb5982d465',
};